import {
  OperationType,
  RentResourceBatchWalletStatus,
} from "@wallet-manager/node-types/dist/src/postgres/const";
import { Fragment, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { NodeTypesEnumMultiSelection } from "src/components/GeneralSelection";
import PageConfigProvider, {
  usePageConfigProviderContext,
} from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";
import { genField } from "src/utils/HelperComp";
import { FilterFields, FilterFieldsKeys } from "../types/FilterFields";
import MpTextFieldMultiple from "src/components/MpTextFieldMultiple";
import { filterNodeTypesEnum } from "src/utils/helper";

const useRenderFilters = () => {
  const { translatePrefix, fields, setFields } = usePageConfigProviderContext<
    FilterFields,
    unknown
  >();

  //handle search params
  const [searchedParams] = useSearchParams();
  const searchedParamsBatchId = searchedParams.get("batchId");
  useEffect(() => {
    if (!searchedParamsBatchId) {
      return;
    }
    setFields(() => ({ ...fields, batchId: searchedParamsBatchId }));
  }, [searchedParamsBatchId]);

  const { t, tc, te } = useTranslation(translatePrefix);

  const onChange =
    (type: FilterFieldsKeys) =>
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const value = e.target.value;
      setFields((fields) => ({ ...fields, [type]: value }));
    };

  const filterFields = genField({ t }, [
    [
      FilterFieldsKeys.CreationTime,
      <PageConfigProvider.DateRangePicker
        type="dateTime"
        onDateRangePicked={(dateRange) => {
          setFields((fields) => ({ ...fields, creationTime: dateRange }));
        }}
      />,
    ],
    [
      FilterFieldsKeys.LastModifiedTime,
      <PageConfigProvider.DateRangePicker
        type="dateTime"
        onDateRangePicked={(dateRange) => {
          setFields((fields) => ({ ...fields, lastModifiedTime: dateRange }));
        }}
      />,
    ],
    // [
    //   FilterFieldsKeys.ChainName,
    //   <ChainSingleSelection
    //     label={tc("phSelection", { fieldName: t(FilterFieldsKeys.ChainName) })}
    //     setChoice={(chainName) => setFields((f) => ({ ...f, chainName }))}
    //     onlyDisplayChainTypes={[3]}
    //     choice={fields.chainName}
    //   />,
    // ],
    [
      FilterFieldsKeys.Status,
      <NodeTypesEnumMultiSelection
        label={tc("phSelection", { fieldName: t(FilterFieldsKeys.Status) })}
        value={fields.status}
        onChange={(status) => setFields({ ...fields, status })}
        nameFn={(name) => te(name as any)}
        enumData={RentResourceBatchWalletStatus}
      />,
    ],
    [
      FilterFieldsKeys.BatchId,
      <MpTextFieldMultiple
        value={fields.batchId}
        label={tc("phInputField", { fieldName: t("batchIdMultiple") })}
        onChange={onChange(FilterFieldsKeys.BatchId)}
        count={
          fields.batchId
            .split(",")
            .filter((item) => item)
            .map((item) => item.trim()).length
        }
      />,
    ],
    [
      FilterFieldsKeys.OperationType,
      <NodeTypesEnumMultiSelection
        label={tc("phSelection", {
          fieldName: t(FilterFieldsKeys.OperationType),
        })}
        value={fields.operationType}
        onChange={(operationType) => setFields({ ...fields, operationType })}
        nameFn={(name) => te(name as any)}
        enumData={filterNodeTypesEnum(OperationType, [
          "MultisignWalletDeployment",
        ])}
      />,
    ],
  ]);

  const renderFields = () =>
    Object.keys(filterFields).map((key, index) => (
      <Fragment key={index}>{filterFields[key]}</Fragment>
    ));

  return { renderFields };
};
export default useRenderFilters;
